module.exports = __webpack_public_path__ + "img/survey.87d5ab9c.png";